module.exports = __webpack_public_path__ + "static/media/success.5ba39ead.mp3";